import { render, staticRenderFns } from "./ot-claim-documents-form.vue?vue&type=template&id=79ff716c&scoped=true&"
import script from "./ot-claim-documents-form.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-documents-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-documents-form.vue?vue&type=style&index=0&id=79ff716c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff716c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VForm,VIcon,VMenu,VTooltip})
